module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patients layout__box"
  }, [_c('table', {
    staticClass: "basic-table",
    attrs: {
      "id": "js-basic-table"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('tr', {
      staticClass: "basic-table__row hr",
      on: {
        "click": function($event) {
          _vm.showCard(client)
        }
      }
    }, [_c('td', {
      staticClass: "basic-table__cell"
    }, [_c('div', {
      staticClass: "basic-table__inner"
    }, [_c('div', {
      staticClass: "basic-table__label"
    }, [_vm._v("Фото:")]), _vm._v(" "), _c('div', {
      staticClass: "basic-table__field"
    }, [_c('div', {
      staticClass: "basic-table__avatar-wrap"
    }, [_c('user-avatar', {
      attrs: {
        "data": client.user,
        "set-class": 'basic-table__avatar'
      }
    })], 1)])])]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell patients__name"
    }, [_c('div', {
      staticClass: "basic-table__inner"
    }, [_c('div', {
      staticClass: "basic-table__label"
    }, [_vm._v("Имя:")]), _vm._v(" "), _c('div', {
      staticClass: "basic-table__field"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(client.user.last_name) + " " + _vm._s(client.user.first_name) + " " + _vm._s(client.user.middle_name) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell"
    }, [_c('div', {
      staticClass: "basic-table__inner"
    }, [_c('div', {
      staticClass: "basic-table__label"
    }, [_vm._v("Пол:")]), _vm._v(" "), _c('div', {
      staticClass: "basic-table__field"
    }, [_vm._v(_vm._s((client.user.sex == 'male') ? 'Муж' : 'Жен'))])])]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell"
    }, [_c('div', {
      staticClass: "basic-table__inner"
    }, [_c('div', {
      staticClass: "basic-table__label"
    }, [_vm._v("Дата рождения:")]), _vm._v(" "), _c('div', {
      staticClass: "basic-table__field"
    }, [_vm._v(_vm._s(_vm._f("moment")([client.user.birthday, 'X'], 'DD.MM.YY')))])])]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell"
    }, [_c('div', {
      staticClass: "basic-table__inner"
    }, [_c('div', {
      staticClass: "basic-table__label"
    }, [_vm._v("Телефон:")]), _vm._v(" "), _c('div', {
      staticClass: "basic-table__field"
    }, [_vm._v("+" + _vm._s(client.user.phone))])])]), _vm._v(" "), _c('td', {
      staticClass: "basic-table__cell"
    }, [_c('div', {
      staticClass: "basic-table__inner"
    }, [_c('div', {
      staticClass: "basic-table__label"
    }, [_vm._v("Последний визит:")]), _vm._v(" "), (client.last_agenda_time) ? _c('div', {
      staticClass: "basic-table__field"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("data")(client.last_agenda_time, 'DD.MM.YYYY')) + "\n\t\t\t\t\t")]) : _c('div', {
      staticClass: "basic-table__field"
    }, [_vm._v(" - ")])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "basic-table__row basic-table__row_headers hr"
  }, [_c('th', {
    staticClass: "basic-table__title"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('th', {
    staticClass: "basic-table__title"
  }, [_vm._v("Фамилия Имя Отчество")]), _vm._v(" "), _c('th', {
    staticClass: "basic-table__title"
  }, [_vm._v("Пол")]), _vm._v(" "), _c('th', {
    staticClass: "basic-table__title"
  }, [_vm._v("Дата рождения")]), _vm._v(" "), _c('th', {
    staticClass: "basic-table__title"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('th', {
    staticClass: "basic-table__title"
  }, [_vm._v("Последний визит")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c6a85e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Clinic/Tabs/Patients.vue
// module id = 579
// module chunks = 0